import {VersionVariants} from '@jobseeker/lotus/enums';
import InputElement from '../V2';
const Input = ({InputProps, sx, ...props}: any) => (
  <InputElement
    InputProps={{style: {fontSize: 10}, ...InputProps}}
    variant={VersionVariants.VERSION_TWO}
    sx={{
      mt: 1,
      input: {padding: '14px 16px'},
      '.MuiInputBase-root': {background: '#F8F8F8'},
      ...sx,
    }}
    {...props}
  />
);
export default Input;
